import { createSlice } from '@reduxjs/toolkit'

import { CommonState } from './types'

const INITIAL_STATE: CommonState = {
  user: { isFetching: false }
}

export const slice = createSlice({
  name: 'common',
  initialState: INITIAL_STATE,

  reducers: {
    successFetchUser: state => {
      state.user.isFetching = false
    },
    errorFetchUser: state => {
      state.user.isFetching = false
      state.user.error = true
    }
  }
})

export const { actions } = slice

export const commonReducer = slice.reducer
